import { Component } from '@verndale/core';

type SeoNavigationProps = {
  currentOpenSection: null | string;
  currentActiveItem: null | HTMLElement | HTMLLIElement;
  documentScrolled: boolean;
};

class SeoNavigation extends Component {
  setupDefaults() {
    this.dom = {
      navItems: this.el.querySelectorAll('.seo-navigation__item')
    };
  }

  addListeners() {
    (this.dom.navItems as NodeList).forEach(node => {
      (node as HTMLLIElement).addEventListener('mouseover', this.handleHover.bind(this));
    });
    document.addEventListener('click', this.handleDocumentClick.bind(this));
    (this.dom.navItems as NodeList).forEach(node => {
      (node as HTMLLIElement).addEventListener('touchend', this.handleTouch.bind(this));
    });

    /**
     * @remarks
     * scenario - user has activated a sub nav on mouseover and then begins to scroll the page
     * we want to handle the anchoring of that open sub nav past the scrollY threshold (50)
     * for a better cleaner UX
     */
    window.addEventListener('scroll', () => {
      if (
        (this.props as SeoNavigationProps).currentOpenSection !== null &&
        (this.props as SeoNavigationProps).currentActiveItem !== null
      ) {
        const subNav = document.getElementById(
          (this.props as SeoNavigationProps).currentOpenSection as string
        ) as HTMLElement;
        if (window.scrollY > 50) {
          this.handleScrollAnchoring(subNav);
        } else {
          (this.props as SeoNavigationProps).documentScrolled = false;
          this.handleScrollAnchoring(subNav);
        }
      }
    });
  }

  handleDocumentClick(event: Event) {
    let subNavClick = false;
    if (
      (this.props as SeoNavigationProps).currentOpenSection !== null &&
      (this.props as SeoNavigationProps).currentActiveItem !== null
    ) {
      const subNav = document.getElementById(
        (this.props as SeoNavigationProps).currentOpenSection as string
      );

      if (event.composedPath().includes(subNav as HTMLElement)) {
        subNavClick = true;
      }

      if (!subNavClick) {
        this.handleClose();
      }
    }
  }

  handleClose() {
    const subNav = document.getElementById(
      (this.props as SeoNavigationProps).currentOpenSection as string
    );
    const activeItem = (this.props as SeoNavigationProps).currentActiveItem;

    if (subNav) {
      (subNav as HTMLElement).style.top = 'auto';
      subNav?.classList.remove('show');
    }

    activeItem?.classList.remove('active');

    (this.props as SeoNavigationProps).currentOpenSection = null;
    (this.props as SeoNavigationProps).currentActiveItem = null;
  }

  handleScrollAnchoring(subNav: HTMLElement) {
    if (!(this.props as SeoNavigationProps).documentScrolled) {
      (this.props as SeoNavigationProps).documentScrolled = true;
      this.calculateTop(subNav);
    } else {
      return;
    }
  }

  calculateTop(subNav: HTMLElement, navAnchor: HTMLLIElement | null = null) {
    if (navAnchor === null) {
      navAnchor = (this.props as SeoNavigationProps).currentActiveItem as HTMLLIElement;
    }

    subNav.style.top =
      navAnchor.getBoundingClientRect().y + navAnchor.getBoundingClientRect().height + 'px';
  }

  positionSubLinks(subNav: HTMLElement, navAnchor: HTMLLIElement | null = null) {
    const items = subNav.querySelector('.seo-navigation__sub-links--items') as HTMLElement;
    items.style.left = (navAnchor?.getBoundingClientRect().left as number) - 16 + 'px';
    items.style.top = '0';
  }

  handleHover(event: Event) {
    const target = event.currentTarget as HTMLLIElement;
    const subNavId = target.getAttribute('aria-controls') as string;
    const subNav = document.getElementById(subNavId);

    if (
      (this.props as SeoNavigationProps).currentOpenSection !== null &&
      (this.props as SeoNavigationProps).currentActiveItem !== null
    ) {
      this.handleClose();
    }

    if (subNav) {
      if (!subNav.classList.contains('moved')) {
        document.body.appendChild(subNav);
        subNav.classList.add('moved');
      }
      (this.props as SeoNavigationProps).currentActiveItem = target;
      target.classList.add('active');
      this.calculateTop(subNav, target);
      this.positionSubLinks(subNav, target);
      subNav.classList.add('show');
      (this.props as SeoNavigationProps).currentOpenSection = subNavId;
      const closeButton = subNav.querySelector('button.close');
      closeButton?.addEventListener('click', this.handleClose.bind(this));
    }
  }

  handleTouch(event: Event) {
    event.preventDefault();
    const target = event.currentTarget as HTMLLIElement;
    const subNavId = target.getAttribute('aria-controls') as string;
    const subNav = document.getElementById(subNavId);
    if (subNav) {
      this.handleHover(event);
    } else {
      const anchor = target.querySelector('a') as HTMLAnchorElement;
      location.href = anchor.href;
    }
  }
}

export default SeoNavigation;
